import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl'

export function translate(intlContext, id, values = {}) {
  return intlContext.formatMessage({ id, ...(values?.defaultMessage && {defaultMessage: values.defaultMessage}) }, values);
}

const Translate = (props) => <FormattedMessage id={props.id} {...props} />

Translate.propTypes = {
  id: PropTypes.string.isRequired
};

export default Translate;
